import HeaderEditorBase from '../../components/HeaderEditorBase/HeaderEditorBase';
import CreationArea from '../CreationArea/CreationArea';
import CreationTools from '../CreationTools/CreationTools';
import React from 'react';
import { Canvas } from 'fabric/fabric-impl';
import useCanvas from '../../hooks/useCanvas';
import { createStore, EditorStore } from '../../store/createStore';
import { Prompt } from 'react-router-dom';
import { useBeforeunload } from 'react-beforeunload';
import { useCanvasEvents } from '../../hooks/useCanvasEvents';
import AppTour from '../AppTour/AppTour';
import { isMobile } from 'react-device-detect';
import ShowIf from '../../components/UI/ShowIf';
import SplashScreenLoading from '../../components/SplashScreenLoading/SplashScreenLoading';
import TitleEditor from "../../components/UI/TitleEditor";

type UseCanvasI = [Canvas, React.RefObject<HTMLCanvasElement>];

interface BaseEditorI {
  selectedCategorySettings: SelectedCategorySettings<any>;
  workArea: {
    height: number;
    width: number;
  };
}

createStore<EditorStore>({
  canvas: undefined,
  dragMode: false,
  prevSelectedTool: undefined,
  activeObjectIText: undefined,
  activeTextEditingMobile: undefined,
  tourStepsRef: [
    {
      index: 0,
      content: '¡Puedes agregar fondos, textos y más elementos a tu composición!',
      positionPopper: isMobile ? 'top-start' : 'top',
      positionPopover: isMobile ? 'topLeft' : 'top',
      ref: undefined,
    },
    {
      index: 1,
      content: 'Puedes cambiar el orden de las imágenes hacia adelante o hacia atrás',
      positionPopper: 'bottom',
      positionPopover: 'bottom',
      ref: undefined,
    },
    {
      index: 2,
      content: 'Descarga tu composición y compártela en tus redes sociales',
      positionPopper: 'bottom-end',
      positionPopover: 'bottomRight',
      ref: undefined,
    },
  ],
  textFormat: {
    fontFamily: 'Akaya Kanadaka',
    fontStyle: 'normal',
    textAlign: 'left',
    bold: false,
    color: '#61C393',
  },
});

function BaseEditor(props: BaseEditorI) {
  const [canvas, canvasRef] = useCanvas({
    height: props.workArea.height,
    width: props.workArea.width,
  }) as UseCanvasI;

  useBeforeunload(() => '¿Está seguro que desea salir sin descargar los cambios?');

  // Configura todos los eventos necesarios que requieren emplearse dentro del Canvas
  useCanvasEvents(canvas);

  return (
    <>
      <ShowIf condition={!canvas}>
        <SplashScreenLoading />
      </ShowIf>
      <Prompt
        when={true}
        message="¿Deseas regresar al menú principal de la aplicación? Si lo haces, se perderá el trabajo realizado."
      />
      <TitleEditor titleName={props.selectedCategorySettings.title}/>
      <HeaderEditorBase />
      <CreationArea canvas={canvas} ref={canvasRef} />
      <CreationTools canvas={canvas} selectedCategorySettings={props.selectedCategorySettings} />
      <AppTour />{' '}
    </>
  );
}

export default BaseEditor;
